import template from './template.html'

angular
  .module('contabilidad.polizasexternas')
  .component('contabilidadPolizasexternasProvisioncomprasboag', {
    controller: ContabilidadPolizasexternasProvisioncomprasboagComponent,
    template,
    bindings: {
      busqueda: '<',
    },
  })

function ContabilidadPolizasexternasProvisioncomprasboagComponent ($location) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.$onChanges = $onChanges
  $ctrl.buscar = buscar

  function $onInit () {

  }

  function $onChanges (changes) {
    if (changes.busqueda)
      $ctrl.busqueda = {
        fechaInicial: changes.busqueda.currentValue.fechaInicial || new Date(),
        fechaFinal: changes.busqueda.currentValue.fechaFinal || new Date(),
      }
  }

  function buscar () {
    $location.search({
      fechaInicial: $ctrl.busqueda.fechaInicial.toYMD(),
      fechaFinal: $ctrl.busqueda.fechaFinal.toYMD(),
    })
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/provisioncomprasboag/component.js